import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useLogosPermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canCreate, canUpdate, canDuplicate, canDelete } = useMemo(
    () => ({
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_LOGO]),
      canUpdate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_LOGO]),
      canDuplicate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_LOGO]),
      canDelete: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_LOGO]),
    }),
    [hasPlatformPermission]
  );

  return {
    canCreate,
    canUpdate,
    canDuplicate,
    canDelete,
  };
};
